import EditComponent from 'modules/addons/components/digital-onboarding/PPSRRegistration/EditComponent';
import ItemComponent from 'modules/addons/components/digital-onboarding/PPSRRegistration/ItemComponent';

const PPSRModuleComponents = {
  Edit: EditComponent,
  Item: ItemComponent,
};

export default PPSRModuleComponents;
